import { ShapeProcess } from "@/shapeStorage/shapes/flowchart/process";

export class ShapeActivity extends ShapeProcess {
    width = 200;
    height = 128;
}
